// extracted by mini-css-extract-plugin
module.exports = {"mapLayerMenu":"MapLayerMenu_mapLayerMenu__tDZmB","buttonIcon":"MapLayerMenu_buttonIcon__2Czxc"};